const delimiters = {
  NAMESPACE_DELIMITER: ':',
};

export default delimiters;
